export default function DashboardLoader() {
  return (
    <>
      {Array.from({ length: 6 }).map((_, index) => (
        <div key={index} className="w-full h-14 bg-base-100 animate-pulse rounded-md border border-base-300 shadow-sm"></div>
      ))}
    </>
  );
}